import { render, staticRenderFns } from "./b2bmarketpurchaser.vue?vue&type=template&id=70fc5a09&scoped=true&"
import script from "./b2bmarketpurchaser.vue?vue&type=script&lang=js&"
export * from "./b2bmarketpurchaser.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./b2bmarketpurchaser.vue?vue&type=style&index=1&id=70fc5a09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc5a09",
  null
  
)

export default component.exports